import { render, staticRenderFns } from "./shareholderList.vue?vue&type=template&id=6dbb71a0&scoped=true&"
import script from "./shareholderList.vue?vue&type=script&lang=js&"
export * from "./shareholderList.vue?vue&type=script&lang=js&"
import style0 from "./shareholderList.vue?vue&type=style&index=0&id=6dbb71a0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbb71a0",
  null
  
)

export default component.exports